 enum TokenType {Auto,True,False};

 export default TokenType;
